import { useCallback } from 'react';
import { useAccountData } from '@src/application/modules/tag/shared/tag/context/useTagData';
import { identifySegment, sendSegment } from './sendSegment';
import { useUserContext } from '@src/application/modules/tag/shared/tag/context/UserContext/useUserContext';

type SegmentParams = {
  email?: string;
  accountName?: string;
  accountId?: number;
  device?: string;
  browser?: string;
  packageName?: string;
};
const useSegment = () => {
  const { profile } = useUserContext();
  const email = profile?.value?.email;
  const userId = profile?.value?.id;
  const { accountId, accountName, ABTastyUA, loading, packageName } = useAccountData();

  const getParams = useCallback((): SegmentParams => {
    const profileParams: SegmentParams = {};
    const tagParams: SegmentParams = {};

    if (email) profileParams.email = email;
    if (!loading) {
      tagParams.accountName = accountName;
      tagParams.accountId = accountId;
      tagParams.device = ABTastyUA.type;
      tagParams.browser = ABTastyUA.browser.name;
    }
    return {
      packageName,
      ...profileParams,
      ...tagParams,
    };
  }, [!!profile, email, accountId, accountName, ABTastyUA.type, ABTastyUA.browser.name, loading]);

  const segmentTrack = useCallback((label: string) => sendSegment(label, getParams()), [getParams]);
  const segmentIdentify = useCallback(() => identifySegment(String(userId), getParams()), [getParams, userId]);

  return { segmentTrack, segmentIdentify };
};

export const useSegmentTrack = () => {
  const { segmentTrack } = useSegment();
  return segmentTrack;
};

export const useSegmentIdentify = () => {
  const { segmentIdentify } = useSegment();
  return segmentIdentify;
};
